import React from 'react';
import './TestResultLoader.css';

export const TestResultLoader: React.FC = () => {
    return (
        <div className="test-loader">
            <h2 className="test-loader__title">Ожидаем результаты теста</h2>

            <div className="test-loader__circle-wrapper">
                <svg
                    className="test-loader__dashed"
                    width="124"
                    height="124"
                    viewBox="0 0 124 124"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="62"
                        cy="62"
                        r="58.5"
                        stroke="#D3D3D3"
                        strokeDasharray="5 5"
                    />
                </svg>

                <svg
                    className="test-loader__rotating"
                    width="124"
                    height="124"
                    viewBox="0 0 124 124"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="62"
                        cy="62"
                        r="49.5"
                        fill="white"
                        stroke="#DDDDDD"
                    />
                    <path
                        d="M49.0609 13.7038C58.0617 11.292 67.5573 11.4435 76.4766 14.1411C85.3959 16.8387 93.3838 21.9751 99.5394 28.9708C105.695 35.9665 109.773 44.5432 111.314 53.7332C112.854 62.9233 111.796 72.361 108.259 80.9817L103.024 78.8336C106.161 71.1885 107.099 62.8188 105.733 54.6688C104.367 46.5187 100.75 38.9127 95.2914 32.7086C89.8324 26.5046 82.7484 21.9495 74.8385 19.5572C66.9286 17.1648 58.5076 17.0305 50.5254 19.1693L49.0609 13.7038Z"
                        fill="#E2EF4A"
                    />
                </svg>
            </div>

            <p className="test-loader__description">
                Подождите, подготовка программы выполняется.<br />
                Это занимает примерно 1–2 минуты.
            </p>
        </div>
    );
};
